// extracted by mini-css-extract-plugin
export default {"scrollbar":"HVScrollBar_module-6FFHAGLA_scrollbar__aYUtG","thumb":"HVScrollBar_module-6FFHAGLA_thumb__U6e9s"};